import { MD5 } from 'crypto-js'; // ES Module


export function md5(message) {
    const hash = MD5(message).toString();
    return hash;
}

// crypto需要在本地和https生产环境中使用
export async function sha256(message) {
  const msgBuffer = new TextEncoder().encode(message);
  const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
}
